import GUI from "lil-gui";

export default class Debug {
    constructor() {
        this.active = document.location.hash === '#debug';

        if (this.active) {
            this.ui = new GUI();
        }
    }
}